(function() {
  'use strict';

  /* jshint undef: true */
  /* global _:false */
  angular
    .module('linshare.quota')
    .constant('_', _);
})();
